<script>
import { defineAsyncComponent } from "vue";
import { Head } from '@inertiajs/vue3';

export default {
    components: {
        BreezeAuthenticatedLayout: defineAsyncComponent(() => import('@/Layouts/Authenticated.vue')),
        Head,
    },
}
</script>

<template>
    <Head title="Dashboard" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Dashboard
            </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div>
                            <p class="mb-5">
                                You are logged in into the IQEQ Identity Provider Solution.
                            </p>
                        </div>
                        <div class="columns-2">
                            <div>
                                <p class="text-lg font-bold mb-2">
                                    This application acts as:
                                </p>
                                <ul class="mb-5 list-disc ml-5">
                                    <li class="mb-2"><strong>Identity Provider</strong><br>Storage of credentials for applications like portals and/or middlewares.</li>
                                    <li class="mb-2"><strong>Identity Server</strong><br>Acting as authority for client tokens.</li>
                                </ul>

                                <h2 class="text-lg font-bold mb-2">
                                    Terminology:
                                </h2>
                                <ul class="mb-5 list-disc ml-5">
                                    <li class="mb-2"><strong>Client</strong><br>API, Portal or middleware using this package to authorize/authenticate.</li>
                                    <li class="mb-2"><strong>User</strong><br>The entity that holds the credentials and profile.</li>
                                    <li class="mb-2"><strong>Profile</strong><br>Meta data around a user, so everything stored on top of credentials.</li>
                                </ul>
                            </div>
                            <div>
                                <p class="text-lg font-bold mb-2">
                                    What can you do? <u class="text-sm font-normal">(when logged in as Root admin)</u>:
                                </p>
                                <ul class="mb-5 list-disc ml-5">
                                    <li class="mb-2"><strong>Import</strong> identity provider <strong>users</strong> for a brand.</li>
                                    <li class="mb-2"><strong>Export</strong> identity provider <strong>users</strong> for a brand.</li>
                                    <li class="mb-2"><strong>Manage user data</strong>: edit email & accountholdercode.</li>
                                    <li class="mb-2"><strong>Manage clients</strong>: generate client & secret, revoke clients, delete.</li>
                                </ul>
                                    
                                <p class="text-lg font-bold mb-2">
                                    What <u>can't</u> you do?:
                                </p>
                                <ul class="mb-5 list-disc ml-5">
                                    <li class="mb-2">Change passwords this should be handled via the portal/middleware.</li>
                                    <li class="mb-2">Change client secrets or view them, these are given once during generation.</li>
                                </ul>
                                <p><br><br></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>